import { useState, useCallback } from 'react';

import { trackPasswordChallenge } from './analytics-helpers';
import { showMfaNeededNotification } from './helpers';
import { useModal } from '../../hooks/use-modal';

type UseNativeVerificationRequiredReturn = {
  nativeVerificationSource: string;
  openNativeVerificationModal: (source: string) => void;
  closeNativeVerificationModal: () => void;
};

export const useNativeVerificationRequired = (): UseNativeVerificationRequiredReturn => {
  const [nativeVerificationSource, setNativeVerificationSource] = useState('');
  const openNativeVerificationModal = useCallback((source: string) => {
    setNativeVerificationSource(source);
  }, []);
  const closeNativeVerificationModal = useCallback(() => {
    setNativeVerificationSource('');
  }, []);

  return {
    nativeVerificationSource,
    openNativeVerificationModal,
    closeNativeVerificationModal,
  };
};

type UseAuth0MfaVerificationRequiredReturn = {
  openMfaModal: (requestUrl: string) => void;
  closeMfaModal: () => void;
  requestUrl: string;
  isMfaModalOpen: boolean;
};

export const useAuth0MfaVerificationRequired = (): UseAuth0MfaVerificationRequiredReturn => {
  const { isOpen, close, open } = useModal();
  const [requestUrl, setRequestUrl] = useState('');

  const openMfaModal = useCallback(
    (_requestUrl: string) => {
      open();
      showMfaNeededNotification();

      setRequestUrl(_requestUrl);
      trackPasswordChallenge({ source: _requestUrl });
    },
    [open],
  );

  const closeMfaModal = useCallback(() => {
    close();
    setRequestUrl('');
  }, [close]);

  return {
    openMfaModal,
    closeMfaModal,
    requestUrl,
    isMfaModalOpen: isOpen,
  };
};
